import { FormHelperText, Tooltip } from "@material-ui/core";
import React, { useState, useEffect } from "react";
import styled, { css } from "styled-components/macro";
import { calculateRequirements } from "../../../utils/calculationUtils";
import { formatCpu, formatBytes } from "../../../utils/productUtils";
import { deriveSecondaryPlan } from "../../../adapters/apSupportAdapter";
import { getDistribution, getBaselineProfile } from "../../../adapters/distributionHelper";
import { getEffectiveScalingProperties, getBaselineExcess } from "../../../adapters/baselineLoadAdapter";
import { resolveServices } from "../../../adapters/dependencyAdapter";
import { ButtonApolloSecondary } from "../../Button/Button";
import NodeWidget from "./NodeWidget";
import StorageWidget  from "./StorageWidget";
import {mdiHarddisk, mdiMemory, mdiCpu64Bit, mdiExpansionCard, mdiAws, mdiMicrosoftAzure} from '@mdi/js';
import {IconButton, Accordion, AccordionSummary, AccordionDetails, Typography } from "@material-ui/core";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import withStyles from "@material-ui/core/styles/withStyles";
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import 'github-markdown-css/github-markdown-light.css';
import Icon from '@mdi/react';
import azureLogo from "./../../../assets/images/azure-storage-logo.png";
import s3Logo from "./../../../assets/images/s3Logo.jpg";
import ResourcesWidget from "./ResourcesWidget";

// SVGs are inlined as data URIs to avoid broken images when the app is served
// through a different origin (e.g. docs.uipath.com proxying to pages.dev).
// CRA 4.x file-loader emits SVGs as separate files with root-relative paths,
// which resolve against the wrong domain in that scenario.
const awsLogo = "data:image/svg+xml;base64,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";
const redisLogo = "data:image/svg+xml;base64,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";
const acrLogo = "data:image/svg+xml;base64,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";
const ecrLogo = "data:image/svg+xml;base64,PHN2ZyBjbGFzcz0idy0zIGgtMyIgaGVpZ2h0PSIyMCIgd2lkdGg9IjIwIiB2aWV3Qm94PSIwIDAgNDAgNDAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8ZGVmcz4KICAgICAgICA8bGluZWFyR3JhZGllbnQgeDE9IjAlIiB5MT0iMTAwJSIgeDI9IjEwMCUiIHkyPSIwJSIgaWQ9IkFyY2hfQW1hem9uLUVsYXN0aWMtQ29udGFpbmVyLVJlZ2lzdHJ5XzMyX3N2Z19fYSI+CiAgICAgICAgICAgIDxzdG9wIHN0b3AtY29sb3I9IiNDODUxMUIiIG9mZnNldD0iMCUiPjwvc3RvcD4KICAgICAgICAgICAgPHN0b3Agc3RvcC1jb2xvcj0iI0Y5MCIgb2Zmc2V0PSIxMDAlIj48L3N0b3A+CiAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgIDwvZGVmcz4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZD0iTTAgMGg0MHY0MEgweiIgZmlsbD0idXJsKCNBcmNoX0FtYXpvbi1FbGFzdGljLUNvbnRhaW5lci1SZWdpc3RyeV8zMl9zdmdfX2EpIj48L3BhdGg+CiAgICAgICAgPHBhdGggZD0iTTE5LjQwNCAxOS4wMDZhLjc5MS43OTEgMCAwMC0uNDA0LjY4NnYxMy4xODNMOSAyNy4xOVYxNC40MDhsMTEuMjUzLTYuMzk2IDkuOTY3IDQuODQ2LTEwLjgxNiA2LjE0OHptMTIuMDUxLTYuMTYzYS43ODguNzg4IDAgMDAtLjQyNC0uNjg4TDIwLjYzOSA3LjEwMmEuODA3LjgwNyAwIDAwLS43ODkuMDAyTDguNDA0IDEzLjYxYS43ODkuNzg5IDAgMDAtLjQwNC42ODZ2MTMuMDA3YS43OS43OSAwIDAwLjQwMi42ODVsMTAuMzkyIDUuOTA3Yy4xMjQuMDcuMjYzLjEwNS40MDIuMTA1YS43OTMuNzkzIDAgMDAuODA0LS43OVYxOS44MDNsMTEuMDU4LTYuMjg1YS43OC43OCAwIDAwLjM5Ny0uNjc2ek0zMiAyNy41MzRsLTkuMDM5IDUuMjl2LTQuOTYybDQuOTk0LTMgLjAzMy0uMjMxYy4wMDktLjA2LjAxMi0uMDYuMDEyLS4zNHYtNS41NDdsNC0yLjI3NHYxMS4wNjR6bS41OTgtMTIuMDgzYS44MTYuODE2IDAgMDAtLjgwNCAwbC00LjQ3MiAyLjU0MmEuNjUuNjUgMCAwMC0uMzIyLjU1MnY1LjczOGwtNC42NDMgMi43ODdhLjc5Ljc5IDAgMDAtLjM5Ni42ODN2NS40MWMwIC4yODYuMTUuNTQyLjQwMS42ODUuMTIzLjA3LjI2Mi4xMDYuNC4xMDZhLjg0Ljg0IDAgMDAuNDExLS4xMDlsOS40MjItNS41MTRhLjc5Ljc5IDAgMDAuNDA1LS42ODdWMTYuMTM1YS43ODEuNzgxIDAgMDAtLjQwMi0uNjg0eiIgZmlsbD0iI0ZGRiI+PC9wYXRoPgogICAgPC9nPgo8L3N2Zz4K";
const dockerLogo = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjQiIGlkPSJMYXllcl8xIiBkYXRhLW5hbWU9IkxheWVyIDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDc1Ni4yNiA1OTYuOSI+CiAgPGRlZnM+CiAgICA8c3R5bGU+CiAgICAgIC5jbHMtMSB7CiAgICAgICAgZmlsbDogIzFkNjNlZDsKICAgICAgICBzdHJva2Utd2lkdGg6IDBweDsKICAgICAgfQogICAgPC9zdHlsZT4KICA8L2RlZnM+CiAgPHBhdGggY2xhc3M9ImNscy0xIiBkPSJNNzQzLjk2LDI0NS4yNWMtMTguNTQtMTIuNDgtNjcuMjYtMTcuODEtMTAyLjY4LTguMjctMS45MS0zNS4yOC0yMC4xLTY1LjAxLTUzLjM4LTkwLjk1bC0xMi4zMi04LjI3LTguMjEsMTIuNGMtMTYuMTQsMjQuNS0yMi45NCw1Ny4xNC0yMC41Myw4Ni44MSwxLjksMTguMjgsOC4yNiwzOC44MywyMC41Myw1My43NC00Ni4xLDI2Ljc0LTg4LjU5LDIwLjY3LTI3Ni43NywyMC42N0guMDZjLS44NSw0Mi40OSw1Ljk4LDEyNC4yMyw1Ny45NiwxOTAuNzcsNS43NCw3LjM1LDEyLjA0LDE0LjQ2LDE4Ljg3LDIxLjMxLDQyLjI2LDQyLjMyLDEwNi4xMSw3My4zNSwyMDEuNTksNzMuNDQsMTQ1LjY2LjEzLDI3MC40Ni03OC42LDM0Ni4zNy0yNjguOTcsMjQuOTguNDEsOTAuOTIsNC40OCwxMjMuMTktNTcuODguNzktMS4wNSw4LjIxLTE2LjU0LDguMjEtMTYuNTRsLTEyLjMtOC4yN1pNMTg5LjY3LDIwNi4zOWgtODEuN3Y4MS43aDgxLjd2LTgxLjdaTTI5NS4yMiwyMDYuMzloLTgxLjd2ODEuN2g4MS43di04MS43Wk00MDAuNzcsMjA2LjM5aC04MS43djgxLjdoODEuN3YtODEuN1pNNTA2LjMyLDIwNi4zOWgtODEuN3Y4MS43aDgxLjd2LTgxLjdaTTg0LjEyLDIwNi4zOUgyLjQydjgxLjdoODEuN3YtODEuN1pNMTg5LjY3LDEwMy4yaC04MS43djgxLjdoODEuN3YtODEuN1pNMjk1LjIyLDEwMy4yaC04MS43djgxLjdoODEuN3YtODEuN1pNNDAwLjc3LDEwMy4yaC04MS43djgxLjdoODEuN3YtODEuN1pNNDAwLjc3LDBoLTgxLjd2ODEuN2g4MS43VjBaIi8+Cjwvc3ZnPg==";




const IconLeftAccordionSummary = withStyles({
  expandIcon: {
    order: -1,
    right: '1%',
  }
})(AccordionSummary);

const Container = styled.div<{ $isAnimating: boolean }>(
  (props) => css`
  border: 1px solid var(--color-border);
  background: var(--color-background);
  border-radius: 3px;
  padding: 20px;
  margin-bottom: 20px;

    ${props.$isAnimating ? `animation: animate-value-text 1s infinite;` : ""}

    @keyframes animate-value-text {
      0% {
        opacity: 1;
      }
      50% {
        opacity: 0;
      }
      100% {
        opacity: 1;
      }
    }
`);

export const SectionHeading = styled.h2`
  color: var(--color-foreground);
  font-size: 1.25rem;
`;

const TotalRequirement = styled.div`
  margin: 0 0 16px;
  padding: 12px 16px;
  background: var(--color-background-secondary);
  border: 1px solid var(--color-border);
  border-radius: 6px;
`;

const TotalRequirementLabel = styled.div`
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--color-foreground-de-emp);
  margin-bottom: 4px;
`;

const TotalRequirementValue = styled.div`
  font-family: monospace;
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 1.2;
  color: var(--color-foreground);
`;

const TotalRequirementNote = styled.div`
  font-size: 12px;
  color: var(--color-foreground-de-emp);
  margin-top: 8px;
`;


const ValueText = styled.span<{ $isAnimating: boolean }>(
  (props) => css`
    font-family: monospace;
    ${props.$isAnimating ? `animation: animate-value-text 1s infinite;` : ""}

    @keyframes animate-value-text {
      0% {
        opacity: 1;
      }
      50% {
        opacity: 0;
      }
      100% {
        opacity: 1;
      }
    }
  `
);

const FlexSection = styled.div`
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  justify-content: flex-start;
  gap: 20px;
  background-color: #f1f6f8;
  margin: 10px;
`;

const FlexSection2 = styled.div`
  display: flex;
  height: 48px;
  left: 0px;
  top: 164px;
  border-radius: 3px;
  background: #F1F6F8;
  margin: 10px;
`;

const Typography1 = styled.div`
  height: 20px;
  padding-left: 18px;
  top: 178px;
  font-family: 'Noto Sans';
  font-style: normal;
  // font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  color: #273139;
`;

const Recommendation = styled.div`
  display: flex;
    flex-direction: row;
    padding-top: 14px;
    padding-left: 20px;
    align-items: center;
    justify-content: flex-start;
    gap: 4px;
`;

const GitHubMarkdown = styled.div`
  ul {
    list-style: disc;
  }
`;



const SiteLabel = styled.div`
  display: inline-block;
  margin: 8px 0 4px 4px;
  padding: 2px 10px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #0c5395;
  background: #e2eefb;
  border-radius: 12px;
`;

const ReplicaChip = styled.span`
  display: inline-block;
  margin-left: 8px;
  padding: 2px 8px;
  font-size: 11px;
  font-weight: 600;
  line-height: 16px;
  color: #4a4a4a;
  background: #ececec;
  border-radius: 10px;
  vertical-align: middle;
`;

let animationTimeout: any = null;

// ---------------------------------------------------------------------------
// Module-level static descriptors for storage and cloud-resources widgets.
// These do not depend on formData and are shared by the Primary and Secondary
// SiteRecommendationAccordion panels.
// ---------------------------------------------------------------------------
const azureStore: StorageType = {
  iconPath: azureLogo,
  storageType: "Object Store",
  storageName: "Azure Storage",
};
const awsStore: StorageType = {
  iconPath: awsLogo,
  storageType: "Object Store",
  storageName: "AWS S3",
};
const odf: StorageType = {
  iconPath: awsLogo,
  storageType: "Object Store",
  storageName: "S3 or Openshift Data Foundation",
};
const azureBackupStore: StorageType = {
  iconPath: azureLogo,
  storageType: "Backup Store",
  storageName: "Azure Storage",
};
const awsBackupStore: StorageType = {
  iconPath: awsLogo,
  storageType: "Backup Store",
  storageName: "AWS S3",
};
const s3Store: StorageType = {
  iconPath: s3Logo,
  storageType: "Object Store",
  storageName: "S3 Compatible Storage",
};
const azureResources: CloudResourcesType = {
  ResourceType: "Other Cloud Resources",
  CacheType: "Azure Cache for Redis",
  CacheIcon: redisLogo,
  RegistryName: "Azure Container Registry",
  RegistryIcon: acrLogo,
};
const awsResources: CloudResourcesType = {
  ResourceType: "Other Cloud Resources",
  CacheType: "ElastiCache for Redis",
  CacheIcon: redisLogo,
  RegistryName: "Elastic Container Registry",
  RegistryIcon: ecrLogo,
};
const openshiftResources: CloudResourcesType = {
  ResourceType: "Other Resources",
  CacheType: "Redis",
  CacheIcon: redisLogo,
  RegistryName: "OCI Compliance Registry",
  RegistryIcon: dockerLogo,
};

// Converts an SVG path into a base64-encoded data URL for inline usage.
// Hoisted to module scope so both Primary and Secondary panels share it.
const getSvgUrl = (path: string, size = 24, color = "currentColor") => {
  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 24 24" fill="${color}">
      <path d="${path}" />
    </svg>
  `;
  return `data:image/svg+xml;base64,${btoa(svg)}`;
};

const storageIcon = getSvgUrl(mdiHarddisk);

/**
 * Renders the per-site sizing accordion body: totals, node widgets, SQL nodes,
 * NFS node, plus the platform-specific storage and cloud-resources widgets.
 * When `label` is provided (e.g. "Primary" / "Secondary") it is shown
 * as a pill above the totals.
 */
const SiteRecommendationAccordion = ({
  site,
  formData,
  isMultizoanl,
  label,
  sqlReplicated,
  apOn,
}: {
  site: SiteResult;
  formData: CalculatorFormDataType;
  isMultizoanl: boolean;
  label?: string;
  sqlReplicated?: boolean;
  apOn?: boolean;
}) => {
  const { deploymentType, host, externalS3, backupEnabled } = formData.highLevelParameters;
  const aiCenterProduct = formData.products.find((product) => product.key === "ai_center");
  // Read the EFFECTIVE pipeline count — sparse/edited stored values must match
  // what the calc provisions (top-level baseline profile; the per-product Lite
  // sub-profile caveat is accepted — see M2-stage5).
  const baselineProfile = getBaselineProfile(deploymentType, formData.highLevelParameters);
  const numberOfPipelines = aiCenterProduct
    ? getEffectiveScalingProperties(
        "ai_center",
        baselineProfile,
        aiCenterProduct.properties || {},
      ).numberOfPipelines
    : undefined;
  // The training-disk card is EXCESS-only, mirroring the handler: pipelines at or
  // below the calibrated baseline carry no extra PVC (the baseline disk is part
  // of the documented reference sizing), so the card hides at zero excess.
  const excessPipelines = getBaselineExcess(
    "ai_center", baselineProfile, "numberOfPipelines", numberOfPipelines || 0,
  );
  const aicDisks: StorageType = {
    iconPath: storageIcon,
    storageType: "Dedicated Disks",
    storageName: `${excessPipelines}*105 GiB For AI Center Training Pipelines (above baseline)`,
  };
  // Context Grounding's flat 1 TiB temporary-storage PVC — same gating as the
  // AITL handler: aitl selected AND the ecs service resolved for it.
  const cgEnabled =
    formData.products.some((p) => p.key === "aitl") &&
    (resolveServices(formData.explicitKeys, getDistribution(deploymentType))
      .productServices.get("aitl") || []).includes("ecs");
  const cgDisks: StorageType = {
    iconPath: storageIcon,
    storageType: "Dedicated Disks",
    storageName: "1 TiB Temporary Storage For Context Grounding",
  };
  const isLinux = ["eval", "ha", "lite"].includes(deploymentType);
  // Replication signals (Replicated chips on object stores + container registry)
  // render ONLY on the Secondary panel. Primary stays clean. `apOn` is still
  // accepted as a prop for backwards compatibility / future use, but the chip
  // gating is now driven strictly by `isSecondary` so that turning A/P on
  // doesn't pollute the Primary panel with replication chips.
  const isSecondary = label === "Secondary";
  const replicationMode = isSecondary ? "replicated" : undefined;
  const replicationLabel = isSecondary ? "Replicated" : undefined;

  return (
    <>
      {label && <SiteLabel>{label}</SiteLabel>}
      {!!(site.totalCpu !== undefined && site.totalRam !== undefined) && (
        <TotalRequirement>
          <TotalRequirementLabel>Total Requirement</TotalRequirementLabel>
          <TotalRequirementValue>
            {formatCpu(site.bufferedCpu ?? site.totalCpu)} / {formatBytes((site.bufferedRam ?? site.totalRam) * 1024 * 1024)}
          </TotalRequirementValue>
          {!!(site.nodes && site.nodes.some(n => n.nodeType?.includes("Dedicated"))) && (
            <TotalRequirementNote>Dedicated nodes have additional resource requirements listed separately below.</TotalRequirementNote>
          )}
        </TotalRequirement>
      )}
      {!!site.nodes && (
        <FlexSection>
          {site.nodes.map(node => <NodeWidget nodeData={node} />)}
        </FlexSection>
      )}
      {!!site.sqlNodes && (
        <FlexSection>
          {sqlReplicated && (
            <div style={{ width: '100%', paddingLeft: 18, paddingTop: 8 }}>
              <ReplicaChip title="Secondary SQL is a replica of the primary site">Replica of Primary</ReplicaChip>
            </div>
          )}
          {site.sqlNodes?.map(
              node => <NodeWidget nodeData={node} />
          )}
        </FlexSection>
      )}
      {isLinux && !!site.nfsNode && (
        <FlexSection>
          <NodeWidget nodeData={site.nfsNode} />
        </FlexSection>
      )}

      {/* Storage widgets — per-site object/backup stores. */}
      {excessPipelines > 0 && (
        <FlexSection2>
          <StorageWidget storageData={aicDisks} />
        </FlexSection2>
      )}
      {cgEnabled && (
        <FlexSection2>
          <StorageWidget storageData={cgDisks} />
        </FlexSection2>
      )}
      {host === "AWS" && isLinux && (
        <FlexSection2>
          <StorageWidget storageData={awsStore} replicationLabel={replicationLabel} />
        </FlexSection2>
      )}
      {host === "Azure" && isLinux && (
        <FlexSection2>
          <StorageWidget storageData={azureStore} replicationLabel={replicationLabel} />
        </FlexSection2>
      )}
      {deploymentType === "air-eks" && (
        <FlexSection2>
          <StorageWidget storageData={{...awsStore, storageSize: "500 GiB"}} replicationLabel={replicationLabel} />
        </FlexSection2>
      )}
      {deploymentType === "air-aks" && (
        <FlexSection2>
          <StorageWidget storageData={{...azureStore, storageSize: "500 GiB"}} replicationLabel={replicationLabel} />
        </FlexSection2>
      )}
      {deploymentType === "air-openshift" && (
        <FlexSection2>
          <StorageWidget storageData={{...odf, storageSize: "500 GiB"}} replicationLabel={replicationLabel} />
        </FlexSection2>
      )}
      {host === "On-Prem" && externalS3 && isLinux && (
        <FlexSection2>
          <StorageWidget storageData={s3Store} replicationLabel={replicationLabel} />
        </FlexSection2>
      )}
      {isLinux && backupEnabled && host === "Azure" && (
        <FlexSection2>
          <StorageWidget storageData={azureBackupStore} />
        </FlexSection2>
      )}
      {isLinux && backupEnabled && host === "AWS" && (
        <FlexSection2>
          <StorageWidget storageData={awsBackupStore} />
        </FlexSection2>
      )}

      {/* Cloud resources widgets — per-site Redis cache + container registry. */}
      {deploymentType === "air-aks" && (
        <FlexSection2>
          <ResourcesWidget resourcedata={azureResources} replicationMode={replicationMode} />
        </FlexSection2>
      )}
      {deploymentType === "air-eks" && (
        <FlexSection2>
          <ResourcesWidget resourcedata={awsResources} replicationMode={replicationMode} />
        </FlexSection2>
      )}
      {deploymentType === "air-openshift" && (
        <FlexSection2>
          <ResourcesWidget resourcedata={openshiftResources} replicationMode={replicationMode} />
        </FlexSection2>
      )}
    </>
  );
};

/**
 * Renders the calculator's debug/markdown details section for the primary
 * site. (Secondary debug is intentionally not rendered — its detail content
 * is a subset of primary, and any A/P-specific guidance is surfaced via
 * `ApRecommendationsSection` below.)
 */
const SiteDetailsSection = ({
  site,
}: {
  site: SiteResult;
}) => {
  if (!site.debug) return null;
  return (
    <div className='markdown-body'>
      <GitHubMarkdown>
        <ReactMarkdown
          children={site.debug.join("\n")}
          remarkPlugins={[remarkGfm]}
          components={{
            a: ({ node, children, href, ...props }) => {
              const isExternal = href?.startsWith('http');
              return (
                <a {...props} href={href} target="_blank" rel="noopener noreferrer">
                  {children}
                  {isExternal && (
                    <OpenInNewIcon
                      style={{
                        fontSize: '0.9em',
                        verticalAlign: 'middle',
                        marginLeft: '3px',
                        marginBottom: '2px',
                      }}
                    />
                  )}
                </a>
              );
            },
          }}
        />
      </GitHubMarkdown>
    </div>
  );
};

/**
 * Renders A/P-specific operational guidance under the Details accordion:
 *   - Per-product callouts for any selected products that were filtered out
 *     of the secondary pass (derived from apSupportAdapter.deriveSecondaryPlan).
 *   - Generic infrastructure recommendations that always apply when running
 *     in A/P mode (SQL AG, object-store CRR, per-site Redis).
 */
const ApRecommendationsSection = ({
  formData,
}: {
  formData: CalculatorFormDataType;
}) => {
  const { deploymentType, version } = formData.highLevelParameters;
  const excludedProductKeys = React.useMemo(
    () =>
      deriveSecondaryPlan(deploymentType, version, getDistribution(deploymentType))
        .excludedProductKeys,
    [deploymentType, version],
  );
  const unsupportedSelected = formData.products.filter((p) =>
    excludedProductKeys.has(p.key),
  );
  return (
    <div className='markdown-body' style={{ marginTop: 12 }}>
      <GitHubMarkdown>
        <h3>Active/Passive Recommendations</h3>
        <ul>
            {unsupportedSelected.map((p) => (
              <li key={p.key}>
                <b>{p.name}</b> is not supported on the secondary site for this
                platform and has been excluded from the secondary sizing.
              </li>
            ))}
            <li>
              Configure SQL Always-On Availability Group between the primary
              and secondary SQL clusters.
            </li>
            <li>
              Enable cross-region replication (CRR) on the object store
              between sites.
            </li>
            <li>
              Provision a separate Redis cache per site. The cache does not
              need to be replicated.
            </li>
          </ul>
      </GitHubMarkdown>
    </div>
  );
};

export const RecommendationWidget = ({
  formData,
  className,
}: {
  formData: CalculatorFormDataType;
  className?: string;
}) => {
  const recommendation = calculateRequirements(formData);
  const primary = recommendation.primary || {};
  const secondary = recommendation.secondary;
  const apOn = !!secondary;
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    clearTimeout(animationTimeout);
    setIsAnimating(true);

    animationTimeout = setTimeout(() => {
      setIsAnimating(false);
    }, 1000);
  }, [formData]);

  return (
    <Container className={className} $isAnimating={isAnimating}>
      <Accordion defaultExpanded={true} data-export-target="recommendation">
        <IconLeftAccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant="h3">Minimal Recommended Configuration</Typography>
        </IconLeftAccordionSummary>

        {!!recommendation.error && (
          <FormHelperText error>
            {recommendation.error}
          </FormHelperText>
        )}

        <SiteRecommendationAccordion
          site={primary}
          formData={formData}
          isMultizoanl={!!formData.highLevelParameters.isMultizoanl}
          label={apOn ? "Primary" : undefined}
          apOn={apOn}
        />

        {apOn && secondary && (
          <SiteRecommendationAccordion
            site={secondary}
            formData={formData}
            isMultizoanl={!!formData.highLevelParameters.isMultizoanl}
            label="Secondary"
            sqlReplicated={true}
            apOn={apOn}
          />
        )}
      </Accordion>
      {!!primary.debug && (
        <Accordion defaultExpanded={false}>
          <IconLeftAccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h3">Details</Typography>
          </IconLeftAccordionSummary>
          <AccordionDetails>
            <div style={{ width: '100%' }}>
              <SiteDetailsSection site={primary} />
              {apOn && <ApRecommendationsSection formData={formData} />}
            </div>
          </AccordionDetails>
        </Accordion>
      )}
    </Container>
  );
};

export default RecommendationWidget;